import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { useReportSelector } from 'components/ReportPage/ReportContext';
import Panel from '../../../../Panels';
import Record from '../../Record';
import { formatSearchTitle } from '../../lib/screenings';
import { CANCELED_STATUS } from '../../lib/constants';

const IntlRightToWork = ({ search }: any) => {
  const accountId = useReportSelector(state => state?.account?.id);

  const panelTitle = search
    ? `${i18n.getStr(
        'components.internationalRightToWork',
      )} - ${formatSearchTitle(search, accountId)}`
    : i18n.getStr('components.internationalRightToWork');

  const isVisible =
    search?.status && ![CANCELED_STATUS].includes(search?.status);

  return (
    <div>
      {isVisible && (
        <Panel
          data-testid='intl-right-to-work'
          title={panelTitle}
          status={search?.status}
        >
          <Record record={search} type='internationalRightToWork' />
        </Panel>
      )}
    </div>
  );
};

IntlRightToWork.propTypes = {
  search: PropTypes.object,
};

IntlRightToWork.defaultProps = {
  search: null,
};

export default IntlRightToWork;
